import axios from "axios";
import React, { useCallback, useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { APPCONFIG } from "../../Config";
import BgLinesBottom from "../../assets/images/default/bgLinesVerifyBottom.png";
import BgLinesTop from "../../assets/images/default/bgLinesVerifyTop.png";
import ClostIcon from "../../assets/images/icon/closeIcon.svg";
import SuccessIcon from "../../assets/images/icon/successIcon.svg";
import VerifyIcon from "../../assets/images/icon/verifyIcon.svg";
import { SUCCESS_CODE } from "../../lib/const";
import { routes } from "../../routes";
import APIEndpoint from "../../services/endpoint";

const Verify = () => {
  const params = useParams();
  const [verified, setVerified] = useState({
    send: false,
    status: false,
  });

  const verify = useCallback(async () => {
    const api =
      APPCONFIG.GATEWAY_ENDPOINT + APIEndpoint.VERIFT_API + `?id=${params.id}`;
    const res = await axios.put(api, {
      headers: { "Content-Type": "application/json" },
    });

    if (res.data?.code === SUCCESS_CODE) {
      setVerified({
        send: true,
        status: true,
      });
    } else {
      setVerified({
        send: true,
        status: false,
      });
    }
  }, [params.id]);

  useEffect(() => {
    setTimeout(() => {
      verify();
    }, 4000);
  }, [params.id, verify]);

  const VerifySection = () => {
    return (
      <>
        <img src={VerifyIcon} width={110} height={110} alt="Verify Icon" />
        <p style={{ fontSize: 24, fontWeight: 700, marginBottom: 15 }}>
          กรุณารอสักครู่
        </p>
        <span style={{ textAlign: "center", color: "#8187A6", fontSize: 18 }}>
          กรุณารอสักครู่ ระบบกำลังทำการยืนยันตัวตน
          <br /> อย่าปิดหน้าจอนี้จนกว่าระบบจะทำการยืนยันตัวตนสำเร็จ
        </span>
      </>
    );
  };

  const VerifiedSuccess = () => {
    return (
      <>
        {verified.send && (
          <>
            <img
              src={verified.status ? SuccessIcon : ClostIcon}
              width={110}
              height={110}
              alt="Verified Success Icon"
            />
            <p style={{ fontSize: 24, fontWeight: 700, marginBottom: 15 }}>
              {verified.status
                ? " บัญชีของคุณได้รับการยืนยันสำเร็จแล้ว"
                : "มีบางอย่างผิดพลาด"}
            </p>
            <span
              style={{ textAlign: "center", color: "#8187A6", fontSize: 18 }}
            >
              {verified.status ? (
                <>
                  ขอแสดงความยินดี! บัญชีใหม่ของคุณได้รับการยืนยันเรียบร้อยแล้ว
                  <br />
                  ท่านสามารถใช้สิทธิประโยชน์เป็นสมาชิกเพื่อเพิ่มประสบการณ์การใช้บริการกับเราได้แล้วครับ/ค่ะ
                </>
              ) : (
                "มีบางอย่างผิดพลาด โปรดทำรายการอีกครั้ง"
              )}
            </span>
            {verified.status && (
              <Link
                className="bg-primary"
                style={{
                  width: 210,
                  padding: "7px 0",
                  textAlign: "center",
                  marginTop: 40,
                  borderRadius: 6,
                  textDecoration: "none",
                  fontSize: 17,
                  fontWeight: 500,
                  zIndex: 1000,
                }}
                to={routes.signin}
              >
                เข้าสู่ระบบ
              </Link>
            )}
          </>
        )}
      </>
    );
  };

  return (
    <div style={{ minHeight: "100vh", position: "relative" }}>
      <div
        style={{
          left: 0,
          backgroundImage: `url(${BgLinesTop})`,
          width: "70%",
          height: "100%",
          position: "absolute",
          backgroundSize: "contain",
          backgroundRepeat: "no-repeat",
          top: -40,
          zIndex: "-1",
        }}
      />
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          minHeight: "100vh",
          flexDirection: "column",
        }}
      >
        {!verified.send ? <VerifySection /> : <VerifiedSuccess />}
      </div>
      <div
        style={{
          backgroundImage: `url(${BgLinesBottom})`,
          width: "70%",
          height: 400,
          position: "absolute",
          backgroundSize: "cover",
          backgroundRepeat: "no-repeat",
          bottom: -20,
          right: 0,
        }}
      />
    </div>
  );
};

export default Verify;
